export const invoiceTypes = [
    {
        "Code": "01",
        "Description": "Invoice"
    },
    {
        "Code": "01A",
        "Description": "Consolidate Invoice"
    },
    {
        "Code": "02",
        "Description": "Credit Note"
    },
    {
        "Code": "03",
        "Description": "Debit Note"
    },
    {
        "Code": "04",
        "Description": "Refund Note"
    },
    {
        "Code": "11",
        "Description": "Self-billed Invoice"
    },
    {
        "Code": "12",
        "Description": "Self-billed Credit Note"
    },
    {
        "Code": "13",
        "Description": "Self-billed Debit Note"
    },
    {
        "Code": "14",
        "Description": "Self-billed Refund Note"
    }
  ]

export const tinNumbers = [
    { name: "General Public" , value: "EI00000000010"},
    { name: "Foreign Buyer/Foreign Shipping Recipient" , value: "EI00000000020"},
    { name: "Foreign Supplier" , value: "EI00000000030"},
    { name: "Buyer" , value: "EI00000000040"},
]

export const invoiceStatus = [
    { value: "All", label: "All" },
    { value: "null", label: "Draft" },
    { value: "Invalid", label: "Invalid" },
  ];


export const importStatus = [
    { value: "All", label: "All" },
    { value: "Completed", label: "Completed" },
    { value: "Failed", label: "Failed" },
]

export const importInvoiceStatus = [
    { value: "All", label: "All" },
    { value: "false", label: "Passed" },
    { value: "true", label: "Failed" },
]